import { type PropsWithChildren } from 'react';

import type { MaskingProps } from '@dynatrace/strato-components/core';

import { DataDtrumContext } from '../../../../core/context/DataDtrumContext.js';
import { MeterBarLayoutSizeContext } from '../../context/MeterBarLayoutSize.context.js';
import { StoreProvider } from '../../providers/StoreProvider.js';
import type { MeterBarSize } from '../../types/meter-bars.js';

interface MeterBarProvidersProps extends MaskingProps {
  size: MeterBarSize;
  segmentHeight: number;
}

export const MeterBarProviders = (
  props: PropsWithChildren<MeterBarProvidersProps>,
) => {
  const {
    size,
    segmentHeight,
    'data-dtrum-allow': dataDtrumAllow,
    'data-dtrum-mask': dataDtrumMask,
    children,
  } = props;

  return (
    <DataDtrumContext.Provider value={{ dataDtrumAllow, dataDtrumMask }}>
      <MeterBarLayoutSizeContext.Provider value={{ size, segmentHeight }}>
        <StoreProvider>{children}</StoreProvider>
      </MeterBarLayoutSizeContext.Provider>
    </DataDtrumContext.Provider>
  );
};
